import { useState } from "react";

const tickerItems = [
  "校学生会换届名单公示后秒删，评论区吵翻",
  "社团账目缺口被网友逐笔比对",
  "奖学金公示期第三次改口径",
  "竞赛金奖「功劳之争」校方介入",
  "二手群跑单话术雷同，疑似一人操作",
  "表白墙深夜工具人长文刷屏",
  "保研风云人物人设全过程复盘",
];

const navLinks = [
  { label: "今日热议", href: "#heat" },
  { label: "风云人物", href: "#people" },
  { label: "避雷名单", href: "#avoid" },
  { label: "干部争议", href: "#cadre" },
  { label: "社团瓜", href: "#club" },
  { label: "翻车回放", href: "#flip" },
  { label: "热议话题", href: "#topic" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="overflow-hidden bg-foreground-950 text-background-50">
        <div className="mx-auto flex max-w-[1280px] items-center gap-3 px-4 py-1.5 md:px-6">
          <span className="inline-flex shrink-0 items-center gap-1.5 text-[11px] font-semibold tracking-wider">
            <i className="ri-flashlight-fill text-accent-400"></i>
            <span className="text-accent-300">快讯</span>
          </span>
          <div className="relative flex-1 overflow-hidden">
            <p className="whitespace-nowrap text-xs text-foreground-200 animate-[ticker_40s_linear_infinite]">
              {tickerItems.join("　·　")}　·　{tickerItems.join("　·　")}
            </p>
          </div>
          <a href="#flip" className="hidden shrink-0 whitespace-nowrap text-[11px] text-accent-300 hover:text-accent-200 md:inline">
            更多现场 →
          </a>
        </div>
      </div>
      <header className="sticky top-0 z-50 border-b border-background-200/80 bg-background-50/85 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-[1280px] items-center justify-between gap-4 px-4 md:px-6">
          <a href="#top" className="flex shrink-0 items-center gap-2.5">
            <span className="relative flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-bug-2-fill text-lg"></i>
              <span className="absolute -right-1 -top-1 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-accent-500 text-[9px] font-bold text-accent-950">
                热
              </span>
            </span>
            <span className="flex flex-col leading-none">
              <h1 className="font-heading text-xl font-extrabold tracking-tight text-foreground-950">
                校园黑料
              </h1>
              <span className="mt-1 text-[10px] font-medium tracking-widest text-foreground-500">
                同学圈避雷中心 · 社交黑瓜一榜看
              </span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 lg:flex">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="rounded-md px-3 py-2 whitespace-nowrap text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-700"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#report"
              className="hidden whitespace-nowrap items-center gap-2 rounded-md border border-primary-200 bg-primary-50 px-3 py-2 text-sm font-semibold text-primary-700 hover:bg-primary-100 sm:inline-flex"
            >
              <i className="ri-megaphone-line text-sm"></i>
              投稿入口
            </a>
            <a
              href="#guard"
              className="hidden whitespace-nowrap items-center gap-2 rounded-md bg-primary-500 px-4 py-2 text-sm font-bold text-background-50 hover:bg-primary-600 sm:inline-flex"
            >
              圈内守则
              <i className="ri-arrow-right-s-line"></i>
            </a>
            <button
              type="button"
              aria-label="菜单"
              onClick={() => setOpen((v) => !v)}
              className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 hover:bg-background-100 lg:hidden"
            >
              <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
            </button>
          </div>
        </div>
        {open && (
          <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
            <div className="flex flex-wrap gap-x-2 gap-y-1">
              {navLinks.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="rounded-full px-3 py-1.5 text-sm font-medium text-foreground-700 hover:bg-background-100"
                >
                  {l.label}
                </a>
              ))}
            </div>
          </div>
        )}
      </header>
    </>
  );
}